export function displayDate(isoString: string | undefined): string {
    if (!isoString) return "";

    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
}

export function displayDateAndTime(isoString: string | undefined, includeSeconds: boolean = false): string {
    if (!isoString) return "";
    const date = new Date(isoString);
    const dateString = displayDate(isoString);
    return `${dateString} ${date.toLocaleTimeString("en", { hour12: false, hour: "numeric", minute: "2-digit", second: includeSeconds ? "2-digit" : undefined })}`;
}

export function displayTimeZonelessDateAndTime(
    dateIsoString: string | undefined,
    timeIsoString: string | undefined,
    includeSeconds: boolean = false
): string {
    if (!dateIsoString || !timeIsoString) return "";
    const dateString = dateIsoString.split("T")[0];
    const timeString = timeIsoString.split("T")[1];
    const year = parseInt(dateString.split("-")[0]);
    const month = parseInt(dateString.split("-")[1]);
    const day = parseInt(dateString.split("-")[2]);
    const hour = parseInt(timeString.split(":")[0]);
    const minute = parseInt(timeString.split(":")[1]);
    const second = parseInt(timeString.split(":")[2]);
    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")} ${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}${includeSeconds ? `:${second.toString().padStart(2, "0")}` : ""}`;
}

export function displayTimeZonelessDate(isoString: string | undefined): string {
    if (!isoString) return "";
    const dateString = isoString.split("T")[0];
    const year = parseInt(dateString.split("-")[0]);
    const month = parseInt(dateString.split("-")[1]);
    const day = parseInt(dateString.split("-")[2]);
    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
}

export function displayDateNoYear(isoString: string | undefined): string {
    if (!isoString) return "";

    const date = new Date(isoString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}/${day}`;
}

export function displayCurrentDateAndTime(includeSeconds: boolean = false): string {
    const date = new Date();
    return displayDateAndTime(date.toISOString(), includeSeconds);
}

export function displayCurrentDate(): string {
    const date = new Date();
    return displayDate(date.toISOString());
}

export function displayTime(isoString: string | undefined, includeSeconds: boolean = false): string {
    if (!isoString) return "";
    const date = new Date(isoString);
    return `${date.toLocaleTimeString("en", { hour12: false, hour: "numeric", minute: "2-digit", second: includeSeconds ? "2-digit" : undefined })}`;
}
